export enum EquipmentDispatchStatusEnum {
  Hold = 1,
  Requested = 2,
  Dispatched = 3,
  Onsite = 4,
  Cancelled = 5,
  Returned = 6,
  Assigned = 7,
}
